import React from 'react';

interface PinToggleIconProps {
  isPinned: boolean;
  className?: string;
  size?: number;
}

export const PinToggleIcon: React.FC<PinToggleIconProps> = ({ 
  isPinned, 
  className = '', 
  size = 16 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask id="mask0_1594_2244" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_1594_2244)">
        <path 
          d="M10.6667 3.33333V8L11.8 9.13333C11.8667 9.2 11.9167 9.275 11.95 9.35833C11.9833 9.44167 12 9.52778 12 9.61667V10C12 10.1889 11.9361 10.3472 11.8083 10.475C11.6806 10.6028 11.5222 10.6667 11.3333 10.6667H8.66667V14.5667C8.66667 14.7556 8.60278 14.9139 8.475 15.0417C8.34722 15.1694 8.18889 15.2333 8 15.2333C7.81111 15.2333 7.65278 15.1694 7.525 15.0417C7.39722 14.9139 7.33333 14.7556 7.33333 14.5667V10.6667H4.66667C4.47778 10.6667 4.31944 10.6028 4.19167 10.475C4.06389 10.3472 4 10.1889 4 10V9.61667C4 9.52778 4.01667 9.44167 4.05 9.35833C4.08333 9.275 4.13333 9.2 4.2 9.13333L5.33333 8V3.33333C5.14444 3.33333 4.98611 3.26944 4.85833 3.14167C4.73056 3.01389 4.66667 2.85556 4.66667 2.66667C4.66667 2.47778 4.73056 2.31944 4.85833 2.19167C4.98611 2.06389 5.14444 2 5.33333 2H10.6667C10.8556 2 11.0139 2.06389 11.1417 2.19167C11.2694 2.31944 11.3333 2.47778 11.3333 2.66667C11.3333 2.85556 11.2694 3.01389 11.1417 3.14167C11.0139 3.26944 10.8556 3.33333 10.6667 3.33333ZM5.9 9.33333H10.1L9.33333 8.56667V3.33333H6.66667V8.56667L5.9 9.33333Z" 
          fill={isPinned ? "currentColor" : "#000"}
        />
      </g>
    </svg>
  );
};
